import { useEffect, useState } from 'react';
import '../../styles/userEntry.scss'
import { useLocation, useNavigate } from 'react-router-dom';
import { useNotification } from '../../context/NotificationContext';
import LoaderBtn from '../LoaderBtn/LoaderBtn';
import { ResetForgotPassword } from '../../api/requests';
import 'animate.css'
import { NavLink } from 'react-router-dom';
import { EyeOff, EyeIcon } from 'lucide-react';

const ResetPasswordSection = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { notify } = useNotification()

    const [inputData, setInputData] = useState({
        new_password: '',
        confirm_password: ''
    })

    const [pageData,setPageData]=useState<any | null>(null)

    const [loader,setLoader]=useState(false)

    const [showNewPassword, setShowNewPassword] = useState(false)
    const [showConfirmPassword, setShowConfirmPassword] = useState(false)


    const state = location.state as any;

    useEffect(() => {
        if (!state || !state.isVerified) {
            navigate('/signin/forgotpassword'); // Go back to previous page
        }else{
            setPageData(state)
            console.log('STate',state)
        }
    }, [state, navigate]);


    if (!state) return null;
    if(!state.isVerified) return null

     const handleInput = (key: string, value: string | boolean) => {
        
        setInputData((prev) => {
            return {
                ...prev,
                [key]: value
            }
        })

    }

    const handleReset=async ()=>{

        if(inputData.new_password ==='' || inputData.confirm_password === ''){
            notify.error('Please fill in required fields')
            return
        }


        if(inputData.new_password !== inputData.confirm_password){
            notify.error('New password and confirm password does not match')
            return
        }

        try {
            setLoader(true)


            let obj={
                email:pageData.email,
                password:inputData.new_password,
                confirm_password:inputData.confirm_password
            }


            let process=await ResetForgotPassword(obj)

            if(process){
               notify.success('Password has been reset successfully')
               navigate('/signin',{replace:true})
            }

        } catch (error:any) {
            notify.error(error.message)
        } finally {
            setLoader(false)
        }

    }

    return (
        <div className='sectionarea animate__animated animate__fadeIn animate__fast'>
            <div className='content'>
                
                <NavLink to={'/'}>
                <div className='logoArea'>
                    <div className='icon logo_initials'></div>
                    <div className='icon logo_name'></div>
                </div>
                </NavLink>

                <div className='intro'>
                    <div className='title'>Reset Password</div>
                    <div className='text'>Please provide us with a new password to confirm your password reset</div>
                </div>


                <div className='inputArea'>


                    <div className='inputPack'>
                        <label className='inputTitle'>New Password</label>
                        <input className='inputBox' type={showNewPassword ? 'text' : 'password'} value={inputData.new_password} onChange={(ev) => handleInput('new_password', ev.currentTarget.value)}></input>
                        <div className='eyepack'>
                            {showNewPassword && (
                                <EyeOff onClick={() => setShowNewPassword((prev) => !prev)}></EyeOff>
                            )}
                            {!showNewPassword && (
                                <EyeIcon onClick={() => setShowNewPassword((prev) => !prev)}></EyeIcon>
                            )}
                        </div>
                    </div>

                    <div className='inputPack'>
                        <label className='inputTitle'>Confirm New Password</label>
                        <input className='inputBox' type={showConfirmPassword ? 'text' : 'password'} value={inputData.confirm_password} onChange={(ev) => handleInput('confirm_password', ev.currentTarget.value)}></input>
                        <div className='eyepack'>
                            {showConfirmPassword && (
                                <EyeOff onClick={() => setShowConfirmPassword((prev) => !prev)}></EyeOff>
                            )}
                            {!showConfirmPassword && (
                                <EyeIcon onClick={() => setShowConfirmPassword((prev) => !prev)}></EyeIcon>
                            )}
                        </div>
                    </div>

                </div>


                <div className='btn_grid'>
                    <LoaderBtn className={'btn'} text={'Reset Password'} clickFunction={handleReset} isLoading={loader}></LoaderBtn>
                </div>


            </div>
        </div>
    )

}


export default ResetPasswordSection;